import { Skeleton } from '@/components/ui/Skeleton.tsx';
import { Card, CardContent, CardHeader } from '@/components/ui/Card.tsx';

const TourConfigInstallmentsPageSkeleton = () => {
  return (
    <div className="space-y-4">
      {/* Breadcrumbs */}
      <div className="flex items-center gap-2 border-b border-neutral-100 pb-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="flex items-center gap-2">
            {i > 0 && <Skeleton className="h-3 w-3" />}
            <div className="flex items-center gap-1">
              <Skeleton className="h-4 w-4 rounded-lg" />
              <Skeleton className="h-4 w-16" />
            </div>
          </div>
        ))}
      </div>

      {/* Header: title + buttons */}
      <div className="flex items-center justify-between pt-4">
        <Skeleton className="h-10 w-64" />
        <div className="flex gap-2">
          <Skeleton className="h-10 w-20" />
          <Skeleton className="h-10 w-20" />
        </div>
      </div>

      {/* Main card */}
      <div className="mx-auto max-w-[600px] space-y-2">
        <Card>
          <CardHeader className="border-b">
            <Skeleton className="h-5 w-40" />
            <Skeleton className="h-4 w-full" />
          </CardHeader>
          <CardContent>
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-4" />
              <Skeleton className="h-4 w-48" />
            </div>
          </CardContent>
          <CardContent className="rounded-b-[13px] bg-neutral-50 p-2">
            <Card>
              <div className="p-3">
                <Skeleton className="h-4 w-24" />
              </div>
              <CardContent className="space-y-3">
                <Skeleton className="h-4 w-full" />
                <div className="space-y-1.5">
                  <Skeleton className="h-4 w-28" />
                  <div className="flex gap-2">
                    <Skeleton className="h-8 w-24" />
                    <Skeleton className="h-8 w-24" />
                    <Skeleton className="h-8 w-24" />
                  </div>
                </div>
                <Skeleton className="h-4 w-32" />
              </CardContent>
            </Card>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TourConfigInstallmentsPageSkeleton;
